<div class="page-container">
  <div *ngIf="pageView !== 'profile'" class="action-buttons">
    <ion-button size="small" color="danger" (click)="closeProfile()">Close</ion-button>
  </div>

  <div class="page">
    <app-profile *ngIf="pageView === 'profile'" [profileId]="profileId" [familyId]="familyId"
      [isNewAppUser]="isNewAppUser" [isCoordinator]="isCoordinator"
      [profileAssignmentId]="profileAssignmentId"></app-profile>
    <app-family *ngIf="isNewAppUser === false && profileId > 0 && pageView === 'family'" [profileId]="profileId"
      [familyId]="familyId"></app-family>
    <app-profile-servants *ngIf="isNewAppUser === false && profileId > 0 && pageView === 'servants'"
      [profileId]="profileId"></app-profile-servants>
    <app-profile-history *ngIf="isNewAppUser === false && profileId > 0 && pageView === 'history'"
      [profileId]="profileId"></app-profile-history>
    <app-profile-reports *ngIf="isNewAppUser === false && profileId > 0 && pageView === 'reports'"
      [profileId]="profileId"></app-profile-reports>
  </div>
  <div #tabcontainer class="tabs-container">
    <ion-label (click)="onPageChange('profile')" [ngClass]="{'selectedPage': pageView === 'profile'}">
      <ion-icon slot="start" name="star"></ion-icon>
      <br>
      Profile
    </ion-label>
    <ion-label *ngIf="profileId > 0" (click)="onPageChange('family')"
      [ngClass]="{'selectedPage': pageView === 'family'}">
      <ion-icon slot="start" name="people"></ion-icon>
      <br>
      Family
    </ion-label>
    <ion-label *ngIf="profileId > 0" (click)="onPageChange('servants')"
      [ngClass]="{'selectedPage': pageView === 'servants'}">
      <ion-icon slot="start" name="business"></ion-icon>
      <br>
      Servants
    </ion-label>
    <ion-label *ngIf="showHistoryTab && profileId > 0" (click)="onPageChange('history')"
      [ngClass]="{'selectedPage': pageView === 'history'}">
      <ion-icon slot="start" name="alarm"></ion-icon>
      <br>
      History
    </ion-label>
    <ion-label *ngIf="profileId > 0" (click)="onPageChange('reports')"
      [ngClass]="{'selectedPage': pageView === 'reports'}">
      <ion-icon slot="start" name="alarm"></ion-icon>
      <br>
      Reports
    </ion-label>
    <!-- <ion-label (click)="onPageChange('attendance')" [ngClass]="{'selectedPage': pageView === 'attendance'}">
      <ion-icon slot="start" name="alarm"></ion-icon>
      <br>
      Attendance
    </ion-label>
    <ion-label (click)="onPageChange('report')" [ngClass]="{'selectedPage': pageView === 'report'}">
      <ion-icon slot="start" name="alarm"></ion-icon>
      <br>
      Report
    </ion-label> -->
  </div>
</div>